import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { api, resolveUrl } from "@/lib/api";
import { toast } from "sonner";

export const ImageUpload = ({ value = [], onChange, multiple = false, max = 10, label = "Φωτογραφίες" }) => {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);
  const list = Array.isArray(value) ? value : value ? [value] : [];

  const handleFiles = async (files) => {
    const arr = Array.from(files).slice(0, max - list.length);
    if (!arr.length) return;
    setUploading(true);
    try {
      const urls = [];
      for (const f of arr) {
        const fd = new FormData();
        fd.append("file", f);
        const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(res.data.url);
      }
      onChange(multiple ? [...list, ...urls] : urls[0]);
    } catch (e) {
      toast.error("Αποτυχία μεταφόρτωσης εικόνας");
    } finally {
      setUploading(false);
    }
  };

  const remove = (i) => {
    const next = list.filter((_, idx) => idx !== i);
    onChange(multiple ? next : next[0] || "");
  };

  return (
    <div>
      <label className="block text-sm font-semibold mb-1.5">{label}</label>
      <div className="flex flex-wrap gap-2">
        {list.map((u, i) => (
          <div key={i} className="relative h-20 w-20 rounded-xl overflow-hidden border border-border group">
            <img src={resolveUrl(u)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => remove(i)} className="absolute top-0.5 right-0.5 h-5 w-5 grid place-items-center rounded-full bg-black/70 text-white opacity-0 group-hover:opacity-100 transition-opacity">
              <X size={12} />
            </button>
          </div>
        ))}
        {(multiple || list.length === 0) && list.length < max && (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            data-testid="image-upload-button"
            className="h-20 w-20 rounded-xl border-2 border-dashed border-border grid place-items-center text-muted-foreground hover:border-primary hover:text-primary transition-colors"
          >
            {uploading ? <Loader2 className="animate-spin" size={20} /> : <Upload size={20} />}
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple={multiple} className="hidden" onChange={(e) => handleFiles(e.target.files)} />
    </div>
  );
};
